module.exports = __webpack_public_path__ + "img/pela_vidda.7e88605e.svg";